import UserProfileTypes from './userDetails.actionTypes';

//update user details
const initialUserState = {
	userid: '',
	userName: '',
	email: '',
	fullName: '',
	phone: '',
	isSubscribe: null,
};

export const setUserDetails = (state = initialUserState, action = {}) => {
	switch (action.type) {
		case UserProfileTypes.SET_USER_DETAILS:
			return Object.assign({}, state, { ...action.payload });
		case UserProfileTypes.UPDATE_USER_PROFILE:
			return Object.assign({}, state, { ...action.payload });
		default:
			return state;
	}
};
